import { graphql } from "~/gql";

export const NOTIFY_COUNT_QUERY = graphql(/* GraphQL */ `
  query NotifyCount($userIds: [Int!]!, $roleIds: [Int!]!, $organisationalUnitIds: [Int!]!) {
    countNotifyUsers(
      userIds: $userIds
      roleIds: $roleIds
      organisationalUnitIds: $organisationalUnitIds
    )
  }
`);
